import React from 'react';
import PropTypes from 'prop-types';
import { AgGridReact } from '@hudl/ag-grid';
import { AgGridThemedWrap } from './StatGrid.styles';

// Shared defaults for every Game Overview box-score grid: no header menu, no
// column reorder/resize, no sorting unless a column opts in, and a dash for
// empty cells. @hudl/ag-grid auto-registers AllEnterpriseModule on import, so
// no ModuleRegistry setup is needed here.
const BASE_DEFAULT_COL_DEF = {
  suppressHeaderMenuButton: true,
  suppressHeaderContextMenu: true,
  resizable: false,
  suppressMovable: true,
  sortable: false,
  valueFormatter: ({ value }) => (value == null || value === '' ? '–' : value),
};

// Thin wrapper around AgGridReact that applies the shared box-score theme and
// column defaults. domLayout defaults to autoHeight so each grid sizes to its
// rows with no inner scroll — right for the short box-score tables. Props are
// listed explicitly (not spread) to satisfy react/jsx-props-no-spreading.
function StatGrid({
  columnDefs,
  rowData,
  context,
  defaultColDef,
  domLayout = 'autoHeight',
  rowHeight,
  headerHeight,
  suppressColumnVirtualisation,
  getRowId,
  onGridReady,
  onFirstDataRendered,
}) {
  return (
    <AgGridThemedWrap>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        context={context}
        defaultColDef={{ ...BASE_DEFAULT_COL_DEF, ...defaultColDef }}
        domLayout={domLayout}
        rowHeight={rowHeight}
        headerHeight={headerHeight}
        suppressColumnVirtualisation={suppressColumnVirtualisation}
        getRowId={getRowId}
        onGridReady={onGridReady}
        onFirstDataRendered={onFirstDataRendered}
        suppressCellFocus
        suppressContextMenu
      />
    </AgGridThemedWrap>
  );
}

StatGrid.propTypes = {
  columnDefs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rowData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  context: PropTypes.shape({}),
  defaultColDef: PropTypes.shape({}),
  domLayout: PropTypes.string,
  rowHeight: PropTypes.number,
  headerHeight: PropTypes.number,
  suppressColumnVirtualisation: PropTypes.bool,
  getRowId: PropTypes.func,
  onGridReady: PropTypes.func,
  onFirstDataRendered: PropTypes.func,
};

export default StatGrid;
